// Libraries
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import React from 'react'
import ReactDOM from 'react-dom'
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { Switch, Route } from 'react-router'
import { QueryClient, QueryClientProvider } from 'react-query'
import { enableES5 } from 'immer'

import configureStore from './utils/configureStore'
import { initializeSentry } from './js/sentry'
import { setReduxStore } from './api'
import Login from './pages/login/Login'
import App from './components/app/App'

const { store, persistor } = configureStore()
setReduxStore(store)

// Initialize third-party libs
enableES5()
initializeSentry()
const queryClient = new QueryClient()

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter basename="/">
          <Switch>
            <Route exact path="/login" component={Login} />
            <Route path="/" component={App} />
          </Switch>
        </BrowserRouter>
      </QueryClientProvider>
    </PersistGate>
  </Provider>,
  document.getElementById('root')
)
